// @owners { team: patient-health }
export const EDIT_REMINDERS = 'EDIT_REMINDERS';
export type ActionEditReminders = {
  type: typeof EDIT_REMINDERS;
  payload: boolean;
};
export function editReminders(isEditing: boolean): ActionEditReminders {
  return {
    type: EDIT_REMINDERS,
    payload: isEditing,
  };
}
